import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router  } from '@angular/router';
import { PrestamosService } from '../../../../services/prestamos.service';
import { EmpleadosServicio } from '../../../../services/empleado.service';
import { Helper } from '../../../../helpers/helper';

// Modales
import { AlertasModales } from '../../../../helpers/alertasModales';
import { ClientesService } from '../../../../services/Clientes.service';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-detalle-prestamo',
  templateUrl: './detalle-prestamo.component.html',
  styleUrls: ['./detalle-prestamo.component.css']
})
export class DetallePrestamoComponent implements OnInit {
  ID_PRESTAMO;
  Prestamo: any;
  recibos = [];
  Math: any;
  loading = false;
  loaded = false;
  verMovimientosPrestamo = false;
  prestamoMovimientos: any;
  documentUrl;
  datosCliente: any;
  constructor(private prestamoService: PrestamosService,
      private route: ActivatedRoute,
      public empleadoService: EmpleadosServicio,
      private clienteService: ClientesService,
      private modals: AlertasModales,
      private router: Router,
      public helper: Helper) {
    this.Math = Math;
    this.documentUrl = `${this.helper.baseUrl}/`;
    route.params.subscribe(res => {
      this.ID_PRESTAMO = res.ID_PRESTAMO;
      this.initPrestamo(res.ID_PRESTAMO);
    });
  }

  ngOnInit() {
  }

  private initPrestamo(ID_PRESTAMO) {
    this.prestamoService.obtenerDetallePrestamo(ID_PRESTAMO).subscribe((data: any) => {
      if (data) {

        for (const cuota of data.cuotas) {
          Object.defineProperty(cuota, 'tiene_mora', { value: cuota.mora > 0, enumerable: true });
        }

        this.Prestamo = data;
        this.verificandoPrestamo();
        setTimeout(() => {

          this.loaded = true;
        }, 1);
      } else {
        this.router.navigate(['/404']);
      }
    }, err => {
      if (err) {

        this.router.navigate(['/404']);
      }
    });
  }

  aprobarPrestamo() {
    this.loading = true;
    this.modals.promptNgbModal('Aprobar préstamo', 'Razón').then((res) => {
    if (res) {
        Object.defineProperty(this.Prestamo, 'razon_aprobado', {value: res.content, enumerable: true});
        this.prestamoService.aprobarPrestamo(this.Prestamo).subscribe(resp => {
            this.loading = false;
            if (resp) {
              this.Prestamo.estado = 1;
              this.Prestamo.fecha_accion = Date.now();
              this.Prestamo.razon_denegado = res.content;
              this.modals.correctoModalJquery(
                'Préstamo aprobado',
                'green',
                'modern',
                'fa fa-usd fa-fw'
              );
            }
          }, (err) => {
            this.loading = false;
          if (err) {
            this.modals.validacionesModalJquery('Error', err.error, 'red');
          }
        });
    } else {
      this.loading = false;
    }
    });
  }

  denegarPrestamo(accion) {
    this.modals.anularNgbModal('préstamo', accion).then(razon => {
      if (razon) {
        const ID_EMPLEADO = this.empleadoService.datosEmpleado.ID_EMPLEADO;
        this.loading = true;

        this.prestamoService.denegarPrestamo(this.ID_PRESTAMO, this.Prestamo.estado, ID_EMPLEADO, razon, this.Prestamo.ID_CLIENTE)
        .subscribe(res => {
          this.loading = false;
          if (res) {
            this.Prestamo.razon_denegado = razon;
            this.Prestamo.estado = 2;
            this.empleadoService.verificarTokenSesion().subscribe( (emp: any) => {
              this.Prestamo.anulado_por = emp.nombreCompleto;
            });
            this.Prestamo.fecha_accion = Date.now();
            this.modals.correctoModalJquery('Préstamo anulado', 'red', 'modern', 'fa fa-usd fa-fw');
          }
        }, err => {
          this.loading = false;
        });
      }
    });
  }

  cobrar() {
    const datos = {
      nombre: this.Prestamo.nombreCliente,
      cedula: this.Prestamo.cedula,
      telefono: this.Prestamo.telefono,
      apodo: this.Prestamo.apodo,
      ID_CLIENTE: this.Prestamo.ID_CLIENTE,
      ID_PRESTAMO: this.ID_PRESTAMO
    };
    localStorage.setItem('realizar_cobro', JSON.stringify(datos));
  }

  movimientosPrestamoClick() {
    this.verMovimientosPrestamo = !this.verMovimientosPrestamo;
    if (this.verMovimientosPrestamo) {
      this.InitMovimientosPrestamo();
    }
  }

  InitMovimientosPrestamo() {
    if (this.verMovimientosPrestamo && this.Prestamo.ID_PRESTAMO !== 'undefined') {
      this.prestamoService.obtenerListaMovimientosPrestamos( this.Prestamo.ID_PRESTAMO, this.Prestamo.compania ).subscribe(data => {
        if (data) {
          this.prestamoMovimientos = data;
        }
      });
    }
  }

  detalleRecibo(recibo) {
    console.log(recibo);
    this.modals.detalleReciboNgbModal(recibo);
  }

  detalleNotaCredito(notaCredito) {
    this.modals.detalleNotaCreditoNgbModal(notaCredito);
  }

  descuentoCuotasNotaCredito(): void {
    this.clienteService.obtenerCliente(this.Prestamo.ID_C).subscribe((data: any) => {
      if (data) {
        this.modals.descuentoCuotasNotaCredito( data, this.ID_PRESTAMO ).then(() => {
          this.prestamoService.obtenerDetallePrestamo(this.ID_PRESTAMO).subscribe(datas => {
          if (datas) {
            this.Prestamo = datas;
          } else {
          this.router.navigate(['/404']);
          }
          }, err => {
          if (err) {
            this.router.navigate(['/404']);
          }
          });
        });
      } else {
        this.router.navigate(['/404']);
      }
    });

  }

  exportarPagare() {
    this.modals.pagareNotarialPDFNgbModal(this.Prestamo);
  }

  anularMoraPrestamo(tipo: number) {
    // tslint:disable-next-line:max-line-length
    const html = `¿Estas seguro que deseas anular la mora del préstamo: <strong>#${this.ID_PRESTAMO}</strong> ${tipo === 1 ? 'temporalmente' : 'definitivamente'}?`;

    this.modals.confirmNgbModal(html, 'Anulación de Mora').then(resp => {
      if (resp && resp === 'si') {
        this.loading = true;
        this.prestamoService.anularMoraPrestamo(this.ID_PRESTAMO, tipo)
        .subscribe(() => {
          this.loading = false;
          this.initPrestamo(this.ID_PRESTAMO);
        }, err => {
          this.loading = false;
          if (err.status == 403) {
            this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
            'red',
            'modern',
            false,
            'fa fa-file-text');
          }
        });
      }
    });

  }

  incluirMora() {
    // tslint:disable-next-line:max-line-length
    const html = `¿Estas seguro que deseas incluirle mora al préstamo: <strong>#${this.ID_PRESTAMO}</strong>?`;

    this.modals.confirmNgbModal(html, 'Inclusión de Mora').then(resp => {
      if (resp && resp === 'si') {
        this.loading = true;
        this.prestamoService.incluirMoraPrestamo(this.ID_PRESTAMO)
        .subscribe(() => {
          this.loading = false;
          this.initPrestamo(this.ID_PRESTAMO);
        }, (err) => {
          this.loading = false;
          if (err.error === 'sin mora') {
            // tslint:disable-next-line:max-line-length
            this.modals.validacionesModalJquery('Error', 'No se pudo incluir mora a este préstamo ya que el porcentaje de mora no ha sido configurado', 'red', 'modern');
          }
        });
      }
    });

  }

  private verificandoPrestamo() {
    if (
      this.Prestamo.estado === 0 &&
      this.Prestamo.empleado_verificando &&
      this.Prestamo.empleado_verificando !== this.empleadoService.datosEmpleado.ID_EMPLEADO) {
        this.modals.validacionesModalJquery('Advertencia',
        `Este préstamo ya está siendo verificado por <b>${this.Prestamo.empleado_verificando_nombre}</b>`,
        'orange',
        'modern',
        false,
        'fa fa-bullhorn');
    }
  }

  editarMoraCuota(cuota) {
    const msg = `${cuota.mora > 0 ? 'Editar' : 'Anular'} la mora de la cuota <b>${ cuota.numero_cuota }</b>`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange')
      .then( res => {
        if (res === 'SI') {
          this.prestamoService.anularMoraCuota(cuota)
          .subscribe(
            () => cuota.auxiliar = cuota.mora,
            err => {
              if (err.status == 403) {
                this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
              }
            });
        } else {
          cuota.mora = cuota.auxiliar;
        }
      });
  }

  pausarMoraPrestamo() {
    this.modals.pausarMoraPrestamoNgbModal(this.ID_PRESTAMO)
    .then(res => {
      if (res) {
        this.initPrestamo(this.ID_PRESTAMO);
      }
    });
  }

  reanudarMoraPrestamo() {
    const msg = `Reanudar la mora de este préstamo`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange')
      .then( res => {
        if (res === 'SI') {
          const data = {
            ID_PRESTAMO: this.ID_PRESTAMO,
            pausar: 'NO'
          };
          this.prestamoService.pausarReaundaMoraPrestamo(data)
          .subscribe(() => {
            this.modals.validacionesModalJquery('Operación realizada con éxito', '', 'green', 'modern', false, 'fa fa-check-circle-o');
            this.initPrestamo(this.ID_PRESTAMO);
          });
        }
      });
  }

  eliminarPrestamo() {
    const decimalPipe = new DecimalPipe('en-US');
    // tslint:disable-next-line:max-line-length
    const msg = `Eliminar el préstamo No. <b>${this.Prestamo.ID}</b> de <b>${decimalPipe.transform(this.Prestamo.capital, '1.0-2')}</b>. Al realizar esta acción usted borrará toda la información relacionada con este préstamo (Pagos, Cuotas, Documentos, etc).`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material')
      .then(res => {
        if (res === 'SI') {
          this.modals.anularNgbModal('préstamo', 'eliminar')
          .then(denegado => {
            if (denegado) {
              this.modals.timingNgbModal(10)
              .then(value => {
                if (value === 'OK') {
                  this.prestamoService.eliminarPrestamo(this.Prestamo.ID, denegado)
                  .subscribe(() => {
                    this.modals.correctoModalJquery('Préstamo eliminado con éxito', 'green', 'modern', 'fa fa-check');
                    this.router.navigate(['/inicio']);
                  }, err => {
                    if (err.status === 404) {
                      this.router.navigate(['/404']);
                    } else if (err.status == 403) {
                      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
                      'red',
                      'modern',
                      false,
                      'fa fa-file-text');
                    }
                  });
                }
              });
            }
          });
        }
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/prestamos/detalle/detalle-prestamo/detalle-prestamo.component.ts